import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const REPORT_ADVICE_QUERY_KEY = "reportAdvice";

/** Refetches every advisor analysis after desks or teams changed. */
export const useInvalidateReportAdvice = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [REPORT_ADVICE_QUERY_KEY]
    });
  }, [queryClient]);
};
